import comp from "./TemplateAttachment";
export default comp;
